import axios from "axios";
import {
  DEVELOPER_DEVELOPERDETAIL_REQUEST,
  DEVELOPER_DEVELOPERDETAIL_SUCCESS,
  DEVELOPER_DEVELOPERDETAIL_FAIL,
  DEVELOPER_DEVELOPERDETAILEDIT_REQUEST,
  DEVELOPER_DEVELOPERDETAILEDIT_SUCCESS,
  DEVELOPER_DEVELOPERDETAILEDIT_FAIL,
  DEVELOPER_APPLY_REQUEST,
  DEVELOPER_APPLY_SUCCESS,
  DEVELOPER_APPLY_FAIL,
  DEVELOPER_APPLY_RESET,
  DEVELOPER_APPLYLIST_REQUEST,
  DEVELOPER_APPLYLIST_SUCCESS,
  DEVELOPER_APPLYLIST_FAIL,
  DEVELOPER_APPLYDETAIL_REQUEST,
  DEVELOPER_APPLYDETAIL_SUCCESS,
  DEVELOPER_APPLYDETAIL_FAIL,
  DEVELOPER_APPLYUPDATE_REQUEST,
  DEVELOPER_APPLYUPDATE_SUCCESS,
  DEVELOPER_APPLYUPDATE_FAIL,
  DEVELOPER_BUILDAPPLYLIST_REQUEST,
  DEVELOPER_BUILDAPPLYLIST_SUCCESS,
  DEVELOPER_BUILDAPPLYLIST_FAIL,
  DEVELOPER_BUILDAPPLY_REQUEST,
  DEVELOPER_BUILDAPPLY_SUCCESS,
  DEVELOPER_BUILDAPPLY_FAIL,
  DEVELOPER_LEARN_REQUEST,
  DEVELOPER_LEARN_SUCCESS,
  DEVELOPER_LEARN_FAIL,
  DEVELOPER_LEARN_RESET,
  DEVELOPER_LEARNLIST_REQUEST,
  DEVELOPER_LEARNLIST_SUCCESS,
  DEVELOPER_LEARNLIST_FAIL,
} from "../constants/developerConstants";
import { detailBuildEmployer } from "../actions/employerAction";
import Api from "../Api";

export const applyDeveloper = (
  skills,
  skillslevel,
  bio,
  cv,
  github,
  history
) => async (dispatch, getState) => {  try {
    dispatch({
      type: DEVELOPER_APPLY_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.post(
      `${Api}/api/developers/apply`,
      { skills, skillslevel, bio, cv, github },
      config
    );

    dispatch({
      type: DEVELOPER_APPLY_SUCCESS,
      payload: res.data,
    });

    history.push("/developer/dashboard");
  } catch (error) {
    dispatch({
      type: DEVELOPER_APPLY_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const detailDeveloper = () => async (dispatch, getState) => {
  try {
    dispatch({ type: DEVELOPER_DEVELOPERDETAIL_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.get(`${Api}/api/developers/apply/user`, config);

    dispatch({
      type: DEVELOPER_DEVELOPERDETAIL_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: DEVELOPER_DEVELOPERDETAIL_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const detailEditDeveloper = (
  name,
  email,
  skills,
  skillslevel,
  bio,
  cv,
  github,
  history
) => async (dispatch, getState) => {
  let avatar = email.trim().toUpperCase()[0];
  try {
    dispatch({
      type: DEVELOPER_DEVELOPERDETAILEDIT_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

     let localItem = localStorage.getItem("userInfo");

     let parseItem = JSON.parse(localItem);

    const res = await axios.put(
      `${Api}/api/developers/apply/edit`,
      { name, email, skills, skillslevel, bio, cv, github },
      config
    );

     let newInfo = {
       _id: parseItem._id,
       name,
       email,
       avatar,
       role: parseItem.role,
       token: parseItem.token,
     };
    
    dispatch({
      type: DEVELOPER_DEVELOPERDETAILEDIT_SUCCESS,
      payload: res.data,
    });

    localStorage.setItem("userInfo", JSON.stringify(newInfo));

    // history.push("/developer/dashboard");
  } catch (error) {
    dispatch({
      type: DEVELOPER_DEVELOPERDETAILEDIT_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const applyBuildDeveloper = (id, history) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({
      type: DEVELOPER_BUILDAPPLY_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.post(
      `${Api}/api/developers/apply/${id}`,
      {},
      config
    );

    dispatch({
      type: DEVELOPER_BUILDAPPLY_SUCCESS,
      payload: res.data,
    });
    window.location.reload();
  } catch (error) {
    dispatch({
      type: DEVELOPER_BUILDAPPLY_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const listBuildApplyDev = () => async (dispatch, getState) => {
  try {
    dispatch({ type: DEVELOPER_BUILDAPPLYLIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.get(
      `${Api}/api/developers/buildApply/user`,
      config
    );
    dispatch({
      type: DEVELOPER_BUILDAPPLYLIST_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: DEVELOPER_BUILDAPPLYLIST_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const learnDeveloper = (phone, country, state, path, history) => async (
  dispatch,
  getState
) => {  try {
    dispatch({
      type: DEVELOPER_LEARN_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.post(
      `${Api}/api/developers/learn`,
      { phone, country, state, path },
      config
    );

    dispatch({
      type: DEVELOPER_LEARN_SUCCESS,
      payload: res.data,
    });

    history.push("/developer/dashboard");
  } catch (error) {
    dispatch({
      type: DEVELOPER_LEARN_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};
